/**
 * StaticSectionHeader - Header section with navigation
 */
import * as breakpoint from '@theme/module-breakpoint';
import Forms from '@theme/core-forms';
import NavMobile from '@theme/component-nav-mobile';
import MegaNavScroller from '@theme/component-meganav-scroller';
import NavDesktopMenu from '@theme/component-nav-desktop-menu';

export default class StaticSectionHeader {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data.settings;
    this.postMessage = section.postMessage;
    this.headerSearch = null;

    this.scriptsEl = document.querySelector('[data-scripts]');

    this.menuToggle = this.el.querySelector('[data-menu-toggle]');
    this.cartCount = this.el.querySelector('[data-header-cart-count]');
    this.searchField = this.el.querySelector('[data-live-search]');

    this.siteNavigation = this.el.querySelector('[data-site-navigation]');
    this.desktopNavigation = this.siteNavigation ? this.siteNavigation.querySelector('ul.navmenu-depth-1') : null;
    this.headerTools = this.siteNavigation ? this.siteNavigation.querySelector('[data-header-actions]') : null;

    const headerProperties = {
      section: section.el,
      postMessage: this.postMessage,
      scriptsEl: this.scriptsEl,
    };

    // Dynamic import for header type
    this._loadHeader(headerProperties);

    this.megaNavs = {};
    const meganavMenus = document.querySelectorAll('[data-meganav-menu]');
    for (let i = 0; i < meganavMenus.length; i++) {
      const el = meganavMenus[i];
      const id = el.getAttribute('data-meganav-id');
      this.megaNavs[id] = new MegaNavScroller(el);
    }

    this.navMobile = new NavMobile({
      el: this.el,
      toggleOpen: this.menuToggle,
    });

    this.navDesktop = new NavDesktopMenu(document.querySelector('.site-navigation > [data-navmenu]'));

    this.forms = new Forms(this.el);

    // Listen for cart count updates
    this._boundCartCountUpdate = (event) => {
      const data = event.detail;
      let itemCount = 0;
      if (data.response.item_count > 0) {
        data.response.items.forEach(item => {
          if (item.properties && item.properties["_for_line_id"]) {
            // Skip
          } else if (item.variant_options.includes('Per Foot')) {
            itemCount++;
          } else {
            itemCount += item.quantity;
          }
        });
      }
      if (this.cartCount) {
        this.cartCount.setAttribute('data-header-cart-count', itemCount);
        this.cartCount.classList.toggle('visible', data.response.item_count > 0);
      }
    };

    this.el.addEventListener('cartcount:update', this._boundCartCountUpdate);
  }

  onSectionDeselect() {
    this._closeAllMeganavs();
    this.header?.sectionDeselect();
  }

  onSectionUnload() {
    this.header?.unload();
    this.navMobile.unload();
    this.navDesktop.unload();
    this.forms.unload();

    this.el.removeEventListener('cartcount:update', this._boundCartCountUpdate);
  }

  onSectionMessage(name, data) {
    if (name === 'nav:close-all' && breakpoint.min('L')) {
      this._closeAllMeganavs();
    }
  }

  onSectionBlockSelect(block) {
    if (!breakpoint.min('L')) {
      return;
    }

    this.header?.onSectionBlockSelect(block);
    if (this.megaNavs[block.id]) {
      this.navDesktop.openMeganavBlock(this.megaNavs[block.id].el);
    }
  }

  onSectionBlockDeselect(block) {
    this.header?.onSectionBlockDeselect(block);

    if (this.megaNavs[block.id]) {
      this.megaNavs[block.id].el.classList.remove('meganav-editing-block');
    }
  }

  _closeAllMeganavs() {
    const keys = Object.keys(this.megaNavs);
    for (let i = 0; keys.length < i; i++) {
      this.megaNavs[keys[i]].el.classList.remove('meganav-editing-block');
    }
  }

  async _loadHeader(headerProperties) {
    let HeaderClass;

    switch (this.settings.header_layout) {
      case 'minimal':
        HeaderClass = (await import('@theme/component-header-minimal')).default;
        break;
      case 'basic':
        HeaderClass = (await import('@theme/component-header-basic')).default;
        break;
      case 'traditional':
      default:
        HeaderClass = (await import('@theme/component-header-traditional')).default;
        break;
    }

    this.header = new HeaderClass(headerProperties, this.settings);
  }
}
